import { z } from 'zod';
export const rivenAuthUiCookieGuard = z
    .object({ appId: z.string(), organizationId: z.string(), uiLocales: z.string() })
    .partial();
